import {DeveloperProjectModel} from "@models/project";
import React from "react";
import {BidSummaryModel} from "@/src/components/bid/bidding_model";
import {Link, useNavigate, useParams} from "react-router-dom";
import {ColumnDef} from "@tanstack/react-table";
import {DataTable} from "../ui/dataTable";
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from "../ui/card";
import {dateFormatter, formatDate, moneyFormatter} from "../../lib/formatters";
import {Button} from "../ui/button";
import {LinkedCell, SortableHeader} from "../ui/tableUtils";

export const _columns: ColumnDef<BidSummaryModel>[] = [
    {
        header: "Company",
        accessorKey: "company.name",
    },
    {
        header: ({column}) => (<SortableHeader column={column} name={"Amount"}/>),
        accessorKey: "latest_bid.bid_amount",
        cell: ({row}) => {
            if (!row.original.latest_bid) {
                return <div className="text-xs">None submitted</div>
            }
            return (
                <Link
                    to={`/project/${row.original.project_id}/bid/${row.original.latest_bid._id}`}
                >
                    <div className="text-lg font-medium hover:underline">
                        {moneyFormatter.format(row.original.latest_bid?.bid_amount)}
                    </div>
                </Link>
            );
        },
    },
    {
        header: ({column}) => (<SortableHeader column={column} name={"Submitted"}/>),
        id: "dss",
        accessorKey: "latest_bid.bid_amount",
        cell: ({row}) => {
            if (!row.original.latest_bid) {
                return <div></div>
            }
            return (
                <div className="font-medium hover:underline">
                    { formatDate(row.original.latest_bid?.submitted_at) }
                </div>
            );
        },
    },
    {
        header: "VE Suggested",
        cell: ({row}) => {
            return (
                <div className="">
                    {moneyFormatter.format(
                        row.original.ve_summary.best_savings_potential
                    )}
                </div>
            );
        },
    },
    {
        header: "Lowest Potential Price",
        cell: ({row}) => {
            if (!row.original.latest_bid) {
                return <div></div>
            }
            const amount = row.original.ve_summary.best_savings_potential
            const formatted = moneyFormatter.format(
                row.original.latest_bid?.bid_amount - amount);
            return (
                <div className="">
                    {formatted}
                </div>
            );
        },
    }
];

const DeveloperBidSummary = ({project}: { project: DeveloperProjectModel }) => {
    const navigate = useNavigate();
    const { project_id } = useParams<string>();
    if (!project) {
        return <></>;
    }
    console.log(project)
    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <div className="flex columns-2 justify-between">
                        <div> Bid Summary</div>
                        <div className="justify-end">
                    <Button
                        variant="outline"
                        onClick={() => navigate(`/project/${project_id}/bidders`)}
                    >
                        Go to Bids
                    </Button>
                        </div>
                    </div>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <DataTable data={project.bid_summary} columns={_columns}/>
            </CardContent>
        </Card>
    );
};

export default DeveloperBidSummary;
